import gql from 'graphql-tag'

export const PRODUCT_ESTIMATED_DELIVERY_FRAGMENT = gql`
  fragment productEstimatedDeliveryFragment on EstimatedDelivery {
    home {
      name
      deliveryFrom
      deliveryTo
      locality
      totalPrice
    }
    pup {
      name
      deliveryFrom
      deliveryTo
      locality
      totalPrice
      type
    }
    cac {
      name
      deliveryFrom
      deliveryTo
      locality
      totalPrice
      type
    }
  }
`
